import reporteriaRouter from "@/views/planilla/reporteria/router/reporteriaRouter";
export default [
    {
        path: "gestion-planillas",
        name: "gestion-planilla",
        component: () =>
            import("@/views/planilla/gestion-planilla/views/IndexPlanilla.vue"),
    },
    {
        path: "gestion-planillas/complementaria/:id",
        name: "gestion-planilla-complementaria",
        component: () =>
            import(
                "@/views/planilla/gestion-planilla/views/AperturaPlanillaComplementaria.vue"
        ),
    },
    {
        path: "gestion-planillas/quincena-veinticinco/:id",
        name: "gestion-planilla-quincena-veinticinco",
        component: () =>
            import("@/views/planilla/gestion-planilla/views/AperturaPlanillaAguinaldo.vue"),
        props: { tipo: "quincena-veinticinco" },
    },
    {
        path: "gestion-planillas/aguinaldo/:id",
        name: "gestion-planilla-aguinaldo",
        component: () =>
            import("@/views/planilla/gestion-planilla/views/AperturaPlanillaAguinaldo.vue"),
        props: { tipo: "aguinaldo" },
    },
    {
        path: "gestion-planillas/ordinaria/:id",
        name: "gestion-planilla-ordinaria",
        component: () =>
            import(
                "@/views/planilla/gestion-planilla/views/MuestraAperturaPlanillaOrdinaria.vue"
            ),
    },
    {
        path: "gestion-planillas/muestra/:id",
        name: "gestion-planilla-ordinaria-muestra",
        component: () =>
            import(
                "@/views/planilla/gestion-planilla/views/PlanillaDetalleView.vue"
            ),
    },
    {
        path: "menu-planillas/:id",
        name: "menu-planilla",
        component: () =>
            import("@/views/acciones-movimientos/planilla/views/MenuPlanilla.vue"),
    },
    {
        path: "menu-planillas/:id/historico-reapertura-planilla",
        name: "historico-reapertura-planilla",
        component: () =>
            import(
                "@/views/acciones-movimientos/planilla/views/HistoricoReaperturaPlanilla.vue"
            ),
    },
    {
        path: "menu-planillas/:id/boleta-de-pago",
        name: "boleta-pago",
        component: () =>
            import("@/views/acciones-movimientos/planilla/views/BoletaPago.vue"),
    },
    ...reporteriaRouter,
    {
        path: "planilla-config-descuentos/:id_planilla",
        name: "config-descuentos",
        component: () =>
            import("@/views/acciones-movimientos/planilla/views/confDescuentos.vue"),
    },
    {
        path: "planilla/configuracion-ingresos/:id_planilla",
        name: "planilla-configuracion-ingresos",
        component: () =>
            import(
                "@/views/acciones-movimientos/planilla/views/ConfiguracionIngresos.vue"
            ),
    },
    {
        path: "planilla/nomina/:id_planilla/:id_tipo_planilla",
        name: "planilla-nomina",
        component: () =>
            import(
            /* webpackChunkName: "planilla-nomina" */ "@/views/acciones-movimientos/planilla/views/Nomina.vue"
            ),
    },
    {
        path: "planilla/nomina/:id_planilla/:id_tipo_planilla/:id_nomina_planilla",
        name: "planilla-nomina-empleado",
        component: () =>
            import(
            /* webpackChunkName: "planilla-nomina" */ "@/views/acciones-movimientos/planilla/views/VisualizacionBoletaPago.vue"
            ),
    },
    {
        path: "/planilla/detalle-nomina/:id_planilla/:id_nomina",
        name: "planilla-nomina-configuracion",
        component: () =>
            import(
            /* webpackChunkName: "planilla-nomina" */ "@/views/acciones-movimientos/planilla/views/PlanillaNominaConfiguracion.vue"
            ),
    },
    {
        path: "/planilla/detalle/:id_planilla/resumen",
        name: "resumen-planilla",
        component: () =>
            import(
                "@/views/acciones-movimientos/planilla/views/ResumenPlanilla.vue"
            ),
    },
    {
        path: "/planilla/:id_planilla/safi",
        name: "archivos-safi",
        component: () =>
            import(
                "@/views/acciones-movimientos/planilla/views/ArchivosSafiView.vue"
            ),
    },
    {
        path: "gestion-planillas-hacienda",
        name: "gestion-planilla-hacienda",
        component: () =>
            import("@/views/planilla/gestion-planilla/views/GestionPanillas.vue"),
    },
    {
        path: "gestion-planillas-hacienda/muestra/:id",
        name: "gestion-planilla-hacienda-muestra",
        component: () =>
            import(
                "@/views/planilla/gestion-planilla/views/PlanillaDetalleHaciendaView.vue"
            ),
    },
];
